import steepImage from "@/assets/image/steep.png";
import udemyImage from "@/assets/image/udemy.png";

export const localizedEducations = {
    en: [
        {
            image: steepImage,
            title: "Computer Academy IT Step",
            subTitle: "Dnipro (2017-2020)",
            text: "Graphic design courses. Creating static web pages using HTML5 and CSS3. UI/UX basics. Adobe Photoshop graphic editor. Creating interfaces for mobile applications and websites with Figma.",
        },
        {
            image: udemyImage,
            title: "Udemy",
            subTitle: "Dnipro (2020-2022)",
            text: "Front-end courses. Basics of HTML and CSS layout. JavaScript (ES6, ES8, ES9, ES2020, ES2022) and React 18 framework.",
        },
        {
            image: udemyImage,
            title: "Udemy",
            subTitle: "Next.js & React – The Complete Guide (2024)",
            text: "Deep understanding of Next.js (versions 13/14), App Router, Pages Router, API Routes, Server-side Rendering (SSR), Static Site Generation (SSG), Client-side Rendering (CSR), authentication strategies, and database integration.",
        },
    ],
    ua: [
        {
            image: steepImage,
            title: "Комп'ютерна Академія ШАГ",
            subTitle: "Дніпро (2017-2020)",
            text: "Курси графічного дизайну. Створення статичних веб-сторінок за допомогою HTML5 і CSS3. Основи UI/UX. Графічний редактор Adobe Photoshop. Створення інтерфейсів для мобільних додатків і веб-сайтів за допомогою Figma.",
        },
        {
            image: udemyImage,
            title: "Udemy",
            subTitle: "Дніпро (2020-2022)",
            text: "Front-end курси. Основи верстки HTML та CSS. JavaScript (ES6, ES8, ES9, ES2020, ES2022) і фреймворк React 18.",
        },
        {
            image: udemyImage,
            title: "Udemy",
            subTitle: "Next.js & React – The Complete Guide (2024)",
            text: "Глибоке розуміння Next.js (версії 13/14), App Router, Pages Router, API Routes, серверного рендерингу (SSR), статичної генерації сайтів (SSG), клієнтського рендерингу (CSR), стратегій автентифікації та інтеграції баз даних.",
        },
    ],
    ru: [
        {
            image: steepImage,
            title: "Компьютерная Академия ШАГ",
            subTitle: "Днепр (2017-2020)",
            text: "Курсы графического дизайна. Создание статических веб-страниц с использованием HTML5 и CSS3. Основы UI/UX. Графический редактор Adobe Photoshop. Создание интерфейсов для мобильных приложений и сайтов с помощью Figma.",
        },
        {
            image: udemyImage,
            title: "Udemy",
            subTitle: "Днепр (2020-2022)",
            text: "Front-end курсы. Основы верстки HTML и CSS. JavaScript (ES6, ES8, ES9, ES2020, ES2022) и фреймворк React 18.",
        },
        {
            image: udemyImage,
            title: "Udemy",
            subTitle: "Next.js & React – The Complete Guide (2024)",
            text: "Глубокое понимание Next.js (версии 13/14), App Router, Pages Router, API Routes, серверного рендеринга (SSR), статической генерации сайтов (SSG), клиентского рендеринга (CSR), стратегий аутентификации и интеграции баз данных.",
        },
    ],
};
